var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container",class:{ 'required-fail': _vm.requiredFail }},_vm._l((_vm.checkboxOptions),function(checkbox){return _c('v-checkbox',{key:checkbox.label,attrs:{"label":checkbox.label,"color":"accent","ripple":false,"disabled":_vm.disabled,"input-value":_vm.value !== null ? _vm.value :
      _vm.valueCheckboxInObject(checkbox.code ? checkbox.uuid : checkbox.var_name)},on:{"change":function($event){return _vm.emitsCheckboxValue(
        checkbox.var_name ? checkbox.var_name : checkbox.uuid,
        $event
      )}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d93c06f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Atoms/InputTypes/InputTypeCheckBox.vue
// module id = null
// module chunks = 